import AddBankAccountAfterSkipContainer from "containers/MyGps/AddBankAccountAfterSkipContainer/AddBankAccountAfterSkipContainer";

const AddBankAccountSyncScreen = () => {
  return(
    <AddBankAccountAfterSkipContainer />
  )
}

export default AddBankAccountSyncScreen;